import { render, staticRenderFns } from "./InputList.vue?vue&type=template&id=827273b2&scoped=true"
import script from "./InputList.vue?vue&type=script&lang=js"
export * from "./InputList.vue?vue&type=script&lang=js"
import style0 from "./InputList.vue?vue&type=style&index=0&id=827273b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827273b2",
  null
  
)

export default component.exports